import type { EntityConfig } from '../types'

export const railEntity: EntityConfig = {
  name: 'rail',
  displayName: 'Rail',
  pluralName: 'Rails',
  status: {
    field: 'status',
    options: ['active', 'inactive', 'pending', 'suspended'],
    filters: [
      { label: 'All', value: 'all' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
      { label: 'Pending', value: 'pending' },
      { label: 'Suspended', value: 'suspended' },
    ],
    mappings: {
      all: ['active', 'inactive', 'pending', 'suspended'],
      active: ['active'],
      inactive: ['inactive'],
      pending: ['pending'],
      suspended: ['suspended'],
    },
  },
  queryFields: {
    status: { field: 'status', type: 'select', label: 'Status' },
    type: { field: 'type', type: 'select', label: 'Type' },
    region: { field: 'region', type: 'select', label: 'Region' },
  },
  uiFilterFields: ['status', 'type', 'region'],
}
